export default __webpack_public_path__ + "static/media/aeroland_slider-sass-image-03.83e0e75e.png";